import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import WeeksPerMonthConfigurationSelector from './_WeeksPerMonthConfigurationSelector'

const WeeksPerMonthConfiguration = ({
  legalEntity,
  weeksPerMonthConfiguration,
}: {
  legalEntity: LegalEntity
  weeksPerMonthConfiguration: React.ComponentProps<
    typeof WeeksPerMonthConfigurationSelector
  >['weeksPerMonthConfiguration']
}) => {
  return (
    <Section
      illustration="clock-app"
      title={i18n.t('settings.legal_entities.legal_entity.contracts.weeks_per_month.title')}
      description={i18n.t(
        'settings.legal_entities.legal_entity.contracts.weeks_per_month.description'
      )}
      paddingX="s0"
    >
      <WeeksPerMonthConfigurationSelector
        weeksPerMonthConfiguration={weeksPerMonthConfiguration}
        legalEntity={legalEntity}
      />
    </Section>
  )
}

export default WeeksPerMonthConfiguration
